



import { AsyncRestClient } from "@/infrastructure/backend/async/AsyncRestClient";
import { onMounted, onUnmounted, ref, reactive, toRefs, defineComponent, watch } from "vue";
import { GeoView , GeoStateAction , GeoState} from "@/components/Shared/geo/hooks/ChangeGeoMap"
import { Out } from "@/infrastructure/frontent/clientMessage";
import { Resource } from "@/infrastructure/resource/resource";
import { UserProfile } from "@/infrastructure/backend/userProfile";
import { GeoStoreData } from "./hooks/GeoStoreData";
import { Navigate } from "@/infrastructure/backend/async/Navigate";
import { ComboBoxDataSource } from "@/components/Shared/Dynamicform/ComboBoxDataSource"
import { geoConvertLib } from "./geo-modules/geo-point-calculations";
import {  geoUtilities } from "./geo-modules/geo-poligon-utilities";
import { geoMarker , GeoCoordinates, GpsState} from "./geo-modules/geo-types";
import { Gps } from "./geo-modules/geo-gps-point";
import { geoMap, SetLeaflet } from "./geo-map/geomap";
import { loadGeoRevier } from "./geo-data/load-revier";
import { GeoJsonUtils } from "./geo-modules/geo-json";
import { GeoJsonRenderer } from "./geo-modules/geo-json-renderer";
import { mapState, useStore } from "vuex";
import { GeoJsonRoot, MapGebietRow } from "./geo-modules/geo-json-types";


/* eslint-disable no-undef */
/* tslint:disable */

export default defineComponent ({
    name: "GeoMap",
    inheritAttrs: false,
    components: {},  
    props: {
            // ReadOnly, New, Change
            editMode: {
                type: String,
                default: "ReadOnly",
                require: false
            },
            // Allowed, OnStartup, Off
            gpsMode: {
                type: String,
                default: "Allowed",
                require: false
            },
            // additional, full, big
            displayClass: {
                type: String,
                default: "additional",
                require: false
            },
            checkInsidePolygon: {
                type: Boolean,
                default: false,
                require: false
            },
            mapDivId: {
                type: String,
                default: "map",
                require: false
            },
            centerVisible: {
                type: Boolean,
                default: true,
                require: false
            },
    },
    setup(props) {     

    const divId = ref<string>(props.mapDivId)
        
    const geoRequestState = {
        editMode: props.editMode,
        gpsMode: props.gpsMode,
        centerVisible: props.centerVisible,
        displayClass: props.displayClass,
        checkInsidePolygon: props.checkInsidePolygon,
        mapDivId: props.mapDivId
    }
    

    
    

    const geoMapState = reactive({
        editActivated: false,
        NotOnlineResourceId: "GeoMap.GeoMapData.NotOnline",
        ActivatedResourceId: "GeoMap.GeoMapData.Activated",
        DeActivatedResourceId: "GeoMap.GeoMapData.DeActivated",
        CenterResourceId: "GeoMap.GeoMapData.Center",
        X_ResourceId: "GeoMap.GeoMapData.X",
        Y_ResourceId: "GeoMap.GeoMapData.Y",
        Activated: "",        
        DeActivated: "",
        NotOnline: "",
        Center: "",
        LabelX: "",
        LabelY: "",
        GpsHintResourceId: "GeoMap.GeoMapData.GpsPositionHint",
        GpsHint: "",
        X: "",
        Y: "",
        RevierNumber: "",
        RevierTyp: "",
        insidePolygon: false,
        displayClass: props.displayClass,
        geoStateAction: GeoStateAction.SetPositionOnly,
        panToGps: false,
        isOnline: true,
        isEditable: GeoStoreData.getEditMode(),
        ZentrumKoordinate: "",
        centerVisible: true,
        geoRevierData: undefined as GeoJsonRoot | string | null | undefined
    })

    

    let gpsPosition: GeoCoordinates | undefined  = undefined	
    let centerPosition: GeoCoordinates | undefined = undefined
    const markers: geoMarker[] = []
    const geoJsonUtilities = new GeoJsonUtils()
    let geoJsonRenderer : GeoJsonRenderer 

    const vueStore = useStore();


    

    async function load() {
        geoMapState.NotOnline = await Resource.getResourceText(geoMapState.NotOnlineResourceId)
        geoMapState.Activated = await Resource.getResourceText(geoMapState.ActivatedResourceId)
        geoMapState.DeActivated = await Resource.getResourceText(geoMapState.DeActivatedResourceId)
        geoMapState.DeActivated = await Resource.getResourceText(geoMapState.Center)
        geoMapState.LabelX = await Resource.getResourceText(geoMapState.X_ResourceId)
        geoMapState.LabelY = await Resource.getResourceText(geoMapState.Y_ResourceId)
        geoMapState.GpsHint = await Resource.getResourceText(geoMapState.GpsHintResourceId)
        geoMapState.ZentrumKoordinate = (await  ComboBoxDataSource.GetValue("SystemParameter", "GeoKoordinateZentrum")) ?? ""
    
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        
    }

    load()

    function getGeoClass() : string  {
        let classString = "rounded "
        classString = classString + geoMapState.displayClass + " "        
        return classString
    }   

    function getGeoClassCentered() : string  {
        let classString = "rounded "
        classString = classString + geoMapState.displayClass + " centered"        
        return classString
    }   


// ***************************************** Action Service *******************************************
const geoViewActionService = GeoView.getService()
const geoViewAction = geoViewActionService.subscription().subscribe({
    next: async (value) => {
        if ( value.action === undefined) {
            return
        }


        if (value.action === GeoStateAction.ChangeData ) {            
            geoRequestState.checkInsidePolygon = true
            geoRequestState.editMode = "Change"
            geoRequestState.gpsMode = "Allowed"
            geoMapState.geoStateAction = value.action
            if ( value.revierNumber && value.typ) {
                geoMapState.RevierNumber = ( value.revierNumber ?? "")
                geoMapState.RevierTyp = (value.typ ?? "")
            }
            if ( !value.revierNumber || ! value.typ ) {
                await loadRevierFromGeoRevier("100000", value.produkt ?? "", "Kanton")
                if ( value.wgs84X && value.wgs84Y && value.wgs84X > 0) {
                    const store = geoViewActionService.getGeoMapStateStore()
                    const point = getGpsFromLv095(value.wgs84Y, value.wgs84X)
                    store.longitude = point[0]
                    store.latitude = point[1]
                    geoMapState.X = value.wgs84Y.toString()
                    geoMapState.Y = value.wgs84X.toString()
                    if (!(await UserProfile.GetCurrentProfile()).online) {
                        geoMapState.editActivated = true
                    }

                    gpsPosition = {
                        longitude: point[0],
                        latitude: point[1]
                    }
                }
                setChangePosition(value, true)                           
                GeoStoreData.Reset()
                geoViewActionService.reset()
                geoMap.disableControlBar(geoMapState.isEditable)      
                return
            }
            if ( value.typ === "fischereirevier" || value.typ === "jagdrevier") {               
                await loadRevierFromGeoRevier(value.revierNumber, value.produkt ?? "", value.typ)
                if ( value.wgs84X && value.wgs84Y  && value.wgs84X > 0) {                    
                    const store = geoViewActionService.getGeoMapStateStore()
                    const point = getGpsFromLv095(value.wgs84Y, value.wgs84X)
                    store.longitude = point[0]
                    store.latitude = point[1]
                    geoMapState.X = value.wgs84Y.toString()
                    geoMapState.Y = value.wgs84X.toString()
                    if (!(await UserProfile.GetCurrentProfile()).online) {
                        geoMapState.editActivated = true
                    }
                    gpsPosition = {
                        longitude: point[0],
                        latitude: point[1]
                    }
                }
                setChangePosition(value, true)
                GeoStoreData.Reset()
                geoViewActionService.reset()  
                geoMap.disableControlBar(geoMapState.isEditable)    
                return
            }                     

            GeoStoreData.Reset()
            geoViewActionService.reset()  
            geoMap.disableControlBar(geoMapState.isEditable)
            return
        }
        
        if ( geoRequestState.editMode === "OnStartup") {
            geoMapState.panToGps = true
        }
 
        if ( value.action === GeoStateAction.SetPositionOnly) {
            geoMapState.geoStateAction = value.action                  
            Gps.CalculateGps("")
            geoViewActionService.reset()  
            geoMap.disableControlBar(geoMapState.isEditable)
            return
        }

        if ( value.action === GeoStateAction.ChangeRevierAndType && (!value.lastState || value.lastState === undefined)) {                    
            geoMapState.geoStateAction = value.action
            geoViewActionService.reset()
            if ( value.revierNumber && value.typ) {
                geoMapState.RevierNumber = ( value.revierNumber ?? "")
                geoMapState.RevierTyp = (value.typ ?? "")
            }
            if ( !value.revierNumber || ! value.typ ) {
                await loadRevierFromGeoRevier("100000", value.produkt ?? "", "Kanton")
                if (geoRequestState.editMode === "Change") {
                    setChangePosition(value, false)
                } else {
                    refreshGpsPosition(true)
                } 
                geoMap.disableControlBar(geoMapState.isEditable)         
                return
            }
            if ( value.typ === "fischereirevier" || value.typ === "jagdrevier") {               
                await loadRevierFromGeoRevier(value.revierNumber, value.produkt ?? "", value.typ)
                if (geoRequestState.editMode === "Change") {
                    setChangePosition(value, false)
                } else {
                    refreshGpsPosition(true)
                }
                geoMap.disableControlBar(geoMapState.isEditable)
                return
            }  
                
        } 

        if ( value.action === GeoStateAction.ChangeRevierAndType && ( value.lastState !== undefined && value.lastState)) {
            geoMapState.geoStateAction = value.action
            if ( value.revierNumber && value.typ) {
                geoMapState.RevierNumber = ( value.revierNumber ?? "")
                geoMapState.RevierTyp = (value.typ ?? "")
            }
            if ( !value.revierNumber || ! value.typ ) {
                await loadRevierFromGeoRevier("100000", value.produkt ?? "", "Kanton")
                if (geoRequestState.editMode === "Change") {
                    const store = geoViewActionService.getGeoMapStateStore()
                    if (store && store.editActice) {
                        geoMapState.editActivated = store.editActice
                    }
                    if ( store && store.longitude && store.latitude ) {
                        gpsPosition = {longitude: store.longitude, latitude: store.latitude}
                        geoMap.setMarker(store.longitude, store.latitude, geoMapState.editActivated)
                        geoViewActionService.reset()
                        geoMap.changeInsideOutsidePosition(store.longitude, store.latitude)                        
                    }
                    if ( store && store.longitudeNorthEast && store.latitudeNorthEast && store.longitudeSouthWest && store.latitudeSouthWest) {
                        geoMap.fitBounds(store.longitudeNorthEast , store.latitudeNorthEast , store.longitudeSouthWest , store.latitudeSouthWest)
                    }
                } else {
                    const store = geoViewActionService.getGeoMapStateStore()
                    if (store && store.editActice) {
                        geoMapState.editActivated = store.editActice
                    }
                    if ( store && store.longitude && store.latitude && store.longitude > 0 ) {
                        gpsPosition = {longitude: store.longitude, latitude: store.latitude}
                        geoMap.setMarker(store.longitude, store.latitude, geoMapState.editActivated)
                        geoViewActionService.reset()
                        geoMap.changeInsideOutsidePosition(store.longitude, store.latitude)                        
                    }
                    if ( store && store.longitudeNorthEast && store.latitudeNorthEast && store.longitudeSouthWest && store.latitudeSouthWest) {
                        geoMap.fitBounds(store.longitudeNorthEast , store.latitudeNorthEast , store.longitudeSouthWest , store.latitudeSouthWest)
                    }
                }      
                geoMap.disableControlBar(geoMapState.isEditable)
                return
            }
            if ( value.typ === "fischereirevier" || value.typ === "jagdrevier") {               
                await loadRevierFromGeoRevier(value.revierNumber, value.produkt ?? "", value.typ)
                if (geoRequestState.editMode === "Change") {
                    const store = geoViewActionService.getGeoMapStateStore()
                    if (store && store.editActice) {
                        geoMapState.editActivated = store.editActice
                    }
                    if ( store && store.longitude && store.latitude  &&  store.longitude > 0 ) {
                        gpsPosition = {longitude: store.longitude, latitude: store.latitude}
                        geoMap.setMarker(store.longitude, store.latitude, geoMapState.editActivated)
                        geoViewActionService.reset()
                        geoMap.changeInsideOutsidePosition(store.longitude, store.latitude)                        
                    }
                    if ( store && store.longitudeNorthEast && store.latitudeNorthEast && store.longitudeSouthWest && store.latitudeSouthWest) {
                        geoMap.fitBounds(store.longitudeNorthEast , store.latitudeNorthEast , store.longitudeSouthWest , store.latitudeSouthWest)
                    }
                } else {
                    const store = geoViewActionService.getGeoMapStateStore()
                    if (store && store.editActice) {
                        geoMapState.editActivated = store.editActice
                    }
                    if ( store && store.longitude && store.latitude && store.longitude > 0) {
                        gpsPosition = {longitude: store.longitude, latitude: store.latitude}
                        geoMap.setMarker(store.longitude, store.latitude, geoMapState.editActivated)
                        geoViewActionService.reset()
                        geoMap.changeInsideOutsidePosition(store.longitude, store.latitude)                        
                    }
                    if ( store && store.longitudeNorthEast && store.latitudeNorthEast && store.longitudeSouthWest && store.latitudeSouthWest) {
                        geoMap.fitBounds(store.longitudeNorthEast , store.latitudeNorthEast , store.longitudeSouthWest , store.latitudeSouthWest)
                    }
                }
                geoMap.disableControlBar(geoMapState.isEditable)
                return
            }          
        } 

        if ( value.action === GeoStateAction.ChangePosition) {
            geoMapState.geoStateAction = value.action
            setChangePosition(value, false)
        }

        geoViewActionService.reset()     
        geoMap.disableControlBar(geoMapState.isEditable)    
    }
})

function setChangePosition(value: GeoState, isLv095: boolean) {

    if ( value.wgs84X &&  value.wgs84X < 1 ) {

        const store = geoViewActionService.getGeoMapStateStore()

        try {
            geoMap.setMarker(store.longitude, store.latitude, geoMapState.editActivated)
        } catch(e) {
            Out.noOperation("")
        }
        geoViewActionService.reset()

        try {
            geoMap.changeInsideOutsidePosition(store.longitude, store.latitude)
        } catch(e) {
            Out.noOperation("")
        }

        return 
    }


    if (value.wgs84X && value.wgs84Y && value.wgs84Y > 0) {

        if ( isLv095) {
            setMarkerFromData(value.wgs84Y, value.wgs84X)
            return
        }

        geoMap.setMarker(value.wgs84X, value.wgs84Y, geoMapState.editActivated)
        geoViewActionService.reset()
        geoMap.changeInsideOutsidePosition(value.wgs84X, value.wgs84Y)


        return
    } 

    if ( geoRequestState.gpsMode === "Allowed" || geoRequestState.gpsMode === "OnStartup") {
        Gps.CalculateGps("")
        geoViewActionService.reset()
        return
    }

    if (centerPosition && centerPosition.longitude && centerPosition.latitude) {
        geoMap.setMarker(centerPosition?.longitude, centerPosition?.latitude, geoMapState.editActivated)    
        geoMap.changeInsideOutsidePosition(centerPosition?.longitude, centerPosition?.latitude)
    }
}

function refreshGpsPosition(isStartup: boolean) {
    if ( isStartup && geoRequestState.gpsMode === "OnStartup") {
        Gps.CalculateGps("Save")
        geoViewActionService.reset()
        return
    }
    if ( !isStartup && (geoRequestState.gpsMode === "Allowed" || geoRequestState.gpsMode === "OnStartup")) {
        Gps.CalculateGps("")
        geoViewActionService.reset()    
        return    
    }
}



async function loadRevierFromGeoRevier(revierNumber: any ,  produkt: string | undefined , typ: string | undefined) : Promise<any | undefined> { 

    if (Navigate.IsLocked()) {
        return undefined
    }


    let mapGebiete = await loadGeoRevier(revierNumber, produkt, typ)

     if ( !mapGebiete ||  mapGebiete.length < 1) {
        mapGebiete = await loadGeoRevier("100000", produkt, "Kanton")        
    }

    if ( !mapGebiete ||  mapGebiete.length < 1) {
        return undefined
    }

    geoJsonUtilities.clear()
    for( const mapGebiet of mapGebiete) {
        geoJsonUtilities.addMapGebiet(mapGebiet)
    }

    geoJsonRenderer.clearLayers()
    geoJsonRenderer.draw(geoJsonUtilities)

    const revierData = geoJsonUtilities.getRevier()
    geoMapState.geoRevierData = revierData?.mapGebietGeoJson

    centerPosition = getCenterPoint(revierData?.mapGebietGeoJson)

    geoMap.SetCenterPosition(centerPosition)

    return revierData

}



function getCenterPoint(data: any) : GeoCoordinates | undefined {
    try {
        const result = geoUtilities.centerInPolygon(data)
        if ( result && result.geometry && result.geometry.coordinates ) {
            return {
                longitude: result.geometry.coordinates[0],
                latitude: result.geometry.coordinates[1]
            }
        }
        return undefined
    } catch(e) {
        Out.noOperation("")
    }
    return undefined
} 

function IsInsidePolygon() {
    if (!geoMapState.isOnline || !geoRequestState.checkInsidePolygon || !geoMapState.RevierNumber || geoMapState.RevierNumber.length < 1)
        return "form-control inside__polygon"

    if (geoMapState.insidePolygon) 
        return "form-control inside__polygon"

    return "form-control outside__polygon"
}

function setMarkerFromCoordinates() {

    try {

        const longitude = geoMapState.X
        const latitude = geoMapState.Y

        const lng = parseInt(longitude)
        const lat = parseInt(latitude)

        const lv03Fromlv095 = geoConvertLib.Lv095ToLv03([lat, lng]);
        const latLng = geoConvertLib.CHtoWGS(lv03Fromlv095[0],lv03Fromlv095[1]);

        const gpsLongitude = latLng[0]
        const gpsLatitude = latLng[1]

        if ( !UserProfile.CurrentProfile.online ) {
            const store = geoViewActionService.getGeoMapStateStore()
            store.longitude = gpsLongitude
            store.latitude = gpsLatitude
            geoViewActionService.changeGeoMapStateStore(store)
            geoMap.sendCurrentGeoState()
        }

        if ( gpsLongitude >= 5.7349 && gpsLongitude <= 10.6677 && gpsLatitude >= 45.6755 && gpsLatitude <= 47.9163 ) {
            geoMap.changeInsideOutsidePosition(gpsLongitude, gpsLatitude)
            setTimeout(()=>{
                try {
                geoMap.removeMarker(1)
                geoMap.newMarker(gpsLongitude, gpsLatitude, 1, geoMapState.editActivated, "" , markers , geoMap.markerHandler )
                
                const store = geoViewActionService.getGeoMapStateStore()
                store.longitude = gpsLongitude
                store.latitude = gpsLatitude
                geoViewActionService.changeGeoMapStateStore(store)
                } catch(e) {
                    Out.noOperation("")
                }
                        
        },0)

            
        }


    } catch (e) {
        Out.noOperation("")
    }
}

function getGpsFromLv095(x:number, y: number) {
    const lng = x
    const lat = y

    const lv03Fromlv095 = geoConvertLib.Lv095ToLv03([lat, lng]);
    const latLng = geoConvertLib.CHtoWGS(lv03Fromlv095[0],lv03Fromlv095[1]);

    return latLng
}



function setMarkerFromData(x: number, y:number) {

try {

  

    const lng = x
    const lat = y

    const lv03Fromlv095 = geoConvertLib.Lv095ToLv03([lat, lng]);
    const latLng = geoConvertLib.CHtoWGS(lv03Fromlv095[0],lv03Fromlv095[1]);

    const gpsLongitude = latLng[0]
    const gpsLatitude = latLng[1]

    if ( gpsLongitude >= 5.7349 && gpsLongitude <= 10.6677 && gpsLatitude >= 45.6755 && gpsLatitude <= 47.9163 ) {
        geoMap.changeInsideOutsidePosition(gpsLongitude, gpsLatitude)
        setTimeout(()=>{
        
            geoMap.removeMarker(1)
            geoMap.newMarker(gpsLongitude, gpsLatitude, 1, geoMapState.editActivated, "" , markers , geoMap.markerHandler )
            
            const store = geoViewActionService.getGeoMapStateStore()
            store.longitude = gpsLongitude
            store.latitude = gpsLatitude
            geoViewActionService.changeGeoMapStateStore(store)
                    
    },0)

        
    }


} catch (e) {
    Out.noOperation("")
}
}


function isEditMode() : boolean {
    if ( geoRequestState.editMode === "ReadOnly") 
        return false
    return true
}

 function enableEditMode() {
    return geoMap.enableEditMode()
 }
 function       disableEditMode() {
    return geoMap.disableEditMode()
 }
 function       toggleEditMode() {
    return geoMap.toggleEditMode()
 }

function isLeafleatPresent() {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore    
    if ( !L || !L.version || L.version.length < 1) {
        return false
    }

    return true

} 

async function showGeoMap() {
    if ( !isLeafleatPresent()) return;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore    
    SetLeaflet(L, divId.value,  geoRequestState, geoMapState, gpsPosition, centerPosition, markers)
    await  geoMap.initMap()

        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
    geoJsonRenderer = new GeoJsonRenderer({ L:L, map:geoMap.getMap(), store: vueStore })         

}


// ******************************************************************************************************************
// Heigeo
// ******************************************************************************************************************


/*!
 * leaflet.wms.js
 * A collection of Leaflet utilities for working with Web Mapping services.
 * (c) 2014-2016, Houston Engineering, Inc.
 * MIT License
 */

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
 (function (factory) {
    // Module systems magic dance, Leaflet edition
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore

    if (typeof define === 'function' && define.amd) {
        // AMD
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
        //define(['leaflet'], factory);
        Out.noOperation("")
    } else if (typeof module !== 'undefined') {
        // Node/CommonJS
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
        //module.exports = factory(require('leaflet'));
        Out.noOperation("")
    } else {
        // Browser globals
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
        if (typeof this.L === 'undefined')
            throw 'Leaflet must be loaded first!';
        // Namespace
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
        this.L.WMS = this.L.wms = factory(this.L);
    }
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore

}(function (L) {

// Module object
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
var wms = {};

// Quick shim for Object.keys()
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
if (!('keys' in Object)) {
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
    Object.keys = function(obj) {
        var result = [];
        for (var i in obj) {
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// tslint:disable-next-line
// eslint-disable-next-line
            if (obj.hasOwnProperty(i)) {
                result.push(i);
            }
        }
        return result;
    };
}

/*
 * wms.Source
 * The Source object manages a single WMS connection.  Multiple "layers" can be
 * created with the getLayer function, but a single request will be sent for
 * each image update.  Can be used in non-tiled "overlay" mode (default), or
 * tiled mode, via an internal wms.Overlay or wms.TileLayer, respectively.
 */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
wms.Source = L.Layer.extend({
    'options': {
        'untiled': true,
        'identify': true
    },
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore

    'initialize': function(url, options) {
        L.setOptions(this, options);
        if (this.options.tiled) {
            this.options.untiled = false;
        }
        this._url = url;
        this._subLayers = {};
        this._overlay = this.createOverlay(this.options.untiled);
    },
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore

    'createOverlay': function(untiled) {
        // Create overlay with all options other than untiled & identify
        var overlayOptions = {};
        for (var opt in this.options) {
            if (opt != 'untiled' && opt != 'identify') {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore

                overlayOptions[opt] = this.options[opt];
            }
        }
        if (untiled) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore

            return wms.overlay(this._url, overlayOptions);
        } else {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore

            return wms.tileLayer(this._url, overlayOptions);
        }
    },

    'onAdd': function() {
        this.refreshOverlay();
    },

    'getEvents': function() {
        if (this.options.identify) {
            return {'click': this.identify};
        } else {
            return {};
        }
    },
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore

    'setOpacity': function(opacity) {
         this.options.opacity = opacity;
         if (this._overlay) {
             this._overlay.setOpacity(opacity);
         }
    },
    
    'bringToBack': function() {
         this.options.isBack = true;
         if (this._overlay) {
             this._overlay.bringToBack();
         }
    },

    'bringToFront': function() {
         this.options.isBack = false;
         if (this._overlay) {
             this._overlay.bringToFront();
         }
    },
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore

    'getLayer': function(name) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore

        return wms.layer(this, name);
    },
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore

    'addSubLayer': function(name) {
        this._subLayers[name] = true;
        this.refreshOverlay();
    },
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore

    'removeSubLayer': function(name) {
        delete this._subLayers[name];
        this.refreshOverlay();
    },

    'refreshOverlay': function() {
        var subLayers = Object.keys(this._subLayers).join(",");
        if (!this._map) {
            return;
        }
        if (!subLayers) {
            this._overlay.remove();
        } else {
            this._overlay.setParams({'layers': subLayers});
            this._overlay.addTo(this._map);
        }
    },
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore

    'identify': function(evt) {
        // Identify map features in response to map clicks. To customize this
        // behavior, create a class extending wms.Source and override one or
        // more of the following hook functions.

        var layers = this.getIdentifyLayers();
        if (!layers.length) {
            return;
        }
        this.getFeatureInfo(
            evt.containerPoint, evt.latlng, layers,
            this.showFeatureInfo
        );
    },
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore

    'getFeatureInfo': function(point, latlng, layers, callback) {
        // Request WMS GetFeatureInfo and call callback with results
        // (split from identify() to faciliate use outside of map events)
        var params = this.getFeatureInfoParams(point, layers),
            url = this._url + L.Util.getParamString(params, this._url);

        this.showWaiting();
        this.ajax(url, done);
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore

        function done(result) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore

            this.hideWaiting();
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore

            var text = this.parseFeatureInfo(result, url);
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore

            callback.call(this, latlng, text);
        }
    },
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore

    'ajax': function(url, callback) {
        ajax.call(this, url, callback);
    },
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore

    'getIdentifyLayers': function() {
        // Hook to determine which layers to identify
        if (this.options.identifyLayers)
            return this.options.identifyLayers;
        return Object.keys(this._subLayers);
     },
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore

    'getFeatureInfoParams': function(point, layers) {
        // Hook to generate parameters for WMS service GetFeatureInfo request
        var wmsParams, overlay;
        if (this.options.untiled) {
            // Use existing overlay
            wmsParams = this._overlay.wmsParams;
        } else {
            // Create overlay instance to leverage updateWmsParams
            overlay = this.createOverlay(true);
            overlay.updateWmsParams(this._map);
            wmsParams = overlay.wmsParams;
            wmsParams.layers = layers.join(',');
        }
        var infoParams = {
            'request': 'GetFeatureInfo',
            'query_layers': layers.join(','),
            'X': Math.round(point.x),
            'Y': Math.round(point.y)
        };
        return L.extend({}, wmsParams, infoParams);
    },
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
    'parseFeatureInfo': function(result, url) {
        // Hook to handle parsing AJAX response
        if (result == "error") {
            // AJAX failed, possibly due to CORS issues.
            // Try loading content in <iframe>.
            result = "<iframe src='" + url + "' style='border:none'>";
        }
        return result;
    },
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore

    'showFeatureInfo': function(latlng, info) {
        // Hook to handle displaying parsed AJAX response to the user
        if (!this._map) {
            return;
        }
        this._map.openPopup(info, latlng);
    },

    'showWaiting': function() {
        // Hook to customize AJAX wait animation
        if (!this._map)
            return;
        this._map._container.style.cursor = "progress";
    },

    'hideWaiting': function() {
        // Hook to remove AJAX wait animation
        if (!this._map)
            return;
        this._map._container.style.cursor = "default";
    }
});
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore

wms.source = function(url, options) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore

    return new wms.Source(url, options);
};

/*
 * Layer
 * Leaflet "layer" with all actual rendering handled via an underlying Source
 * object.  Can be called directly with a URL to automatically create or reuse
 * an existing Source.  Note that the auto-source feature doesn't work well in
 * multi-map environments; so for best results, create a Source first and use
 * getLayer() to retrieve wms.Layer instances.
 */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore

wms.Layer = L.Layer.extend({
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore

    'initialize': function(source, layerName, options) {
        L.setOptions(this, options);
        if (!source.addSubLayer) {
            // Assume source is a URL
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore

            source = wms.getSourceForUrl(source, options);
        }
        this._source = source;
        this._name = layerName;
    },
    'onAdd': function() {
        if (!this._source._map)
            this._source.addTo(this._map);
        this._source.addSubLayer(this._name);
    },
    'onRemove': function() {
        this._source.removeSubLayer(this._name);
    },
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore

    'setOpacity': function(opacity) {
        this._source.setOpacity(opacity);
    },
    'bringToBack': function() {
        this._source.bringToBack();
    },
    'bringToFront': function() {
        this._source.bringToFront();
    }
});
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore

wms.layer = function(source, options) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore

    return new wms.Layer(source, options);
};

// Cache of sources for use with wms.Layer auto-source option
var sources = {};
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore

wms.getSourceForUrl = function(url, options) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore

    if (!sources[url]) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore

        sources[url] = wms.source(url, options);
    }
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore

    return sources[url];
};


// Copy tiled WMS layer from leaflet core, in case we need to subclass it later
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore

wms.TileLayer = L.TileLayer.WMS;
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore

wms.tileLayer = L.tileLayer.wms;

/*
 * wms.Overlay:
 * "Single Tile" WMS image overlay that updates with map changes.
 * Portions of wms.Overlay are directly extracted from L.TileLayer.WMS.
 * See Leaflet license.
 */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore

wms.Overlay = L.Layer.extend({
    'defaultWmsParams': {
        'service': 'WMS',
        'request': 'GetMap',
        'version': '1.1.1',
        'layers': '',
        'styles': '',
        'format': 'image/jpeg',
        'transparent': false
    },

    'options': {
        'crs': null,
        'uppercase': false,
        'attribution': '',
        'opacity': 1,
        'isBack': false,
        'minZoom': 0,
        'maxZoom': 18
    },
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore

    'initialize': function(url, options) {
        this._url = url;

        // Move WMS parameters to params object
        var params = {}, opts = {};
        for (var opt in options) {
             if (opt in this.options) {
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore

                 opts[opt] = options[opt];
             } else {
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore

                 params[opt] = options[opt];
             }
        }
        L.setOptions(this, opts);
        this.wmsParams = L.extend({}, this.defaultWmsParams, params);
    },
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore

    'setParams': function(params) {
        L.extend(this.wmsParams, params);
        this.update();
    },

    'getAttribution': function() {
        return this.options.attribution;
    },

    'onAdd': function() {
        this.update();
    },
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore

    'onRemove': function(map) {
        if (this._currentOverlay) {
            map.removeLayer(this._currentOverlay);
            delete this._currentOverlay;
        }
        if (this._currentUrl) {
            delete this._currentUrl;
        }
    },

    'getEvents': function() {
        return {
            'moveend': this.update
        };
    },

    'update': function() {
        if (!this._map) {
            return;
        }
        // Determine image URL and whether it has changed since last update
        this.updateWmsParams();
        var url = this.getImageUrl();
        if (this._currentUrl == url) {
            return;
        }
        this._currentUrl = url;

        // Keep current image overlay in place until new one loads
        // (inspired by esri.leaflet)
        var bounds = this._map.getBounds();
        var overlay = L.imageOverlay(url, bounds, {'opacity': 0});
        overlay.addTo(this._map);
        overlay.once('load', _swap, this);
        function _swap() {
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore

            if (!this._map) {
                return;
            }
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
            if (overlay._url != this._currentUrl) {
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore

                this._map.removeLayer(overlay);
                return;
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
            } else if (this._currentOverlay) {
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore

                this._map.removeLayer(this._currentOverlay);
            }
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore

            this._currentOverlay = overlay;
            overlay.setOpacity(
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
                this.options.opacity ? this.options.opacity : 1
            );
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
            if (this.options.isBack === true) {
                overlay.bringToBack();
            }
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
            if (this.options.isBack === false) {
                overlay.bringToFront();
            }
        }
        if ((this._map.getZoom() < this.options.minZoom) ||
            (this._map.getZoom() > this.options.maxZoom)){
            this._map.removeLayer(overlay);
        }
    },

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
    'setOpacity': function(opacity) {
         this.options.opacity = opacity;
         if (this._currentOverlay) {
             this._currentOverlay.setOpacity(opacity);
         }
    },

    'bringToBack': function() {
        this.options.isBack = true;
        if (this._currentOverlay) {
            this._currentOverlay.bringToBack();
        }
    },

    'bringToFront': function() {
        this.options.isBack = false;
        if (this._currentOverlay) {
            this._currentOverlay.bringToFront();
        }
    },

    // See L.TileLayer.WMS: onAdd() & getTileUrl()
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
    'updateWmsParams': function(map) {
        if (!map) {
            map = this._map;
        }
        // Compute WMS options
        var bounds = map.getBounds();
        var size = map.getSize();
        var wmsVersion = parseFloat(this.wmsParams.version);
        var crs = this.options.crs || map.options.crs;
        var projectionKey = wmsVersion >= 1.3 ? 'crs' : 'srs';
        var nw = crs.project(bounds.getNorthWest());
        var se = crs.project(bounds.getSouthEast());

        // Assemble WMS parameter string
        var params = {
            'width': size.x,
            'height': size.y
        };
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
        params[projectionKey] = crs.code;
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
        params.bbox = (
            wmsVersion >= 1.3 && crs === L.CRS.EPSG4326 ?
            [se.y, nw.x, nw.y, se.x] :
            [nw.x, se.y, se.x, nw.y]
        ).join(',');

        L.extend(this.wmsParams, params);
    },

    'getImageUrl': function() {
        var uppercase = this.options.uppercase || false;
        var pstr = L.Util.getParamString(this.wmsParams, this._url, uppercase);
        return this._url + pstr;
    }
});

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
wms.overlay = function(url, options) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
    return new wms.Overlay(url, options);
};

// Simple AJAX helper (since we can't assume jQuery etc. are present)
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
function ajax(url, callback) {
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
// tslint:disable-next-line
// eslint-disable-next-line
    var context = this,
    request = new XMLHttpRequest();
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore

    request.onreadystatechange = change;
    request.open('GET', url);
    request.send();

    function change() {
        if (request.readyState === 4) {
            if (request.status === 200) {
                callback.call(context, request.responseText);
            } else {
                callback.call(context, "error");
            }
        }
    }
}

return wms;

}));

// ******************************************************************************************************************
// Heigeo End
// ******************************************************************************************************************


onMounted(async () => {
    
    //console.log("GeoMap.vue onMounted: " + divId.value)
    await showGeoMap()
})

onUnmounted(() => {
    //console.log("GeoMap.vue onUnmounted: " + divId.value)
    
    geoViewAction.unsubscribe()
    // geoMap.removeMarker(1)
    // geoMap.cleanUp()

    
})
   
    return {
        enableEditMode,
        disableEditMode,
        toggleEditMode,
        geoMapState,
        IsInsidePolygon,
        setMarkerFromCoordinates,
        isEditMode,
        getGeoClass,
        getGeoClassCentered,        
        divId
        }
    }
});
